
























import Vue from 'vue';
import {
  Datepicker,
  DatepickerMode,
  DatepickerValidationMode,
  IDatepickerErrorObject,
} from '@ringana/datepicker';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';

interface IDatepickerInputComponent {
  DatepickerMode: typeof DatepickerMode;
  DatepickerValidationMode: typeof DatepickerValidationMode;
  months: string[];
}

export default Vue.extend({
  name: `DatepickerInput`,
  components: { Datepicker },
  data(): IDatepickerInputComponent {
    return {
      DatepickerMode,
      DatepickerValidationMode,
      months: [`1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`],
    };
  },
  props: {
    enableEmptyDatepickerSelection: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: ``,
      type: String,
    },
  },
  mounted(): void {
    this.initMonthStrings();
  },
  methods: {
    handleDatepickerError($event: IDatepickerErrorObject): void {
      ErrorHandlerHelper.handleError($event.errorText, {
        logToConsole: true,
      });
    },
    initMonthStrings(): void {
      // This currently checks if Locize is initialized.
      // If Locize is not initialized the default values defined in 'data' are used.
      try {
        this.$t(`datepicker:months.january`);
      } catch (err) {
        return;
      }

      this.months = [
        this.$t(`datepicker:months.january`),
        this.$t(`datepicker:months.february`),
        this.$t(`datepicker:months.march`),
        this.$t(`datepicker:months.april`),
        this.$t(`datepicker:months.may`),
        this.$t(`datepicker:months.june`),
        this.$t(`datepicker:months.july`),
        this.$t(`datepicker:months.august`),
        this.$t(`datepicker:months.september`),
        this.$t(`datepicker:months.october`),
        this.$t(`datepicker:months.november`),
        this.$t(`datepicker:months.december`),
      ].map(month => month.toUpperCase());
    },
  },
});
